import src from "IMAGE";
export default { src, width: 343, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARElEQVR42jXGKw7AIAwAUESbrB/HtswyV4dsuABobsH9LwACxEteEJF7eZaXmaOqfkQU/5Syu/eAiHwAwLUvZlZarWMCjogFUuhJFCEAAAAASUVORK5CYII="};
